/*
$(document).ready(function() {
    // Initialize add to cart buttons
    initializeAddToCartButtons();

    function initializeAddToCartButtons() {
        const $addToCartButtons = $(".add-to-cart-btn");
        $addToCartButtons.each(function() {
            $(this).on("click", function() {
                const variantId = $(this).data("variant-id");
                addToCart(variantId);
            });
        });
    }

    function addToCart(variantId) {
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: JSON.stringify({ id: variantId, quantity: 1 }),
            dataType: 'json',
            contentType: 'application/json',
            success: function(data) {
                console.log('Item added to cart:', data);
                updateCartCounter();
                renderMiniCartItem(data);
                openMiniCart();
            },
            error: function(error) {
                console.error('Error:', error);
            }
        });
    }

    function updateCartCounter() {
        $.getJSON('/cart.js', function(data) {
            $(".cart-count").text(data.item_count);
        }).fail(function(error) {
            console.error('Error:', error);
        });
    }

    function renderMiniCartItem(item) {
        const $miniCartItemsContainer = $('.mini-cart__items');
        $miniCartItemsContainer.empty(); // Clear previous items

        $miniCartItemsContainer.append(`
            <div class="mini-cart__item d-flex align-items-center">
                <img src="${item.image}" alt="${item.title}" class="mini-cart__item-image img-fluid rounded" style="max-width: 50px; max-height: 50px; margin-right: 10px;">
                <div class="mini-cart__item-details">
                    <h5 class="mb-1">${item.title}</h5>
                </div>
            </div>
        `);
    }

    function openMiniCart() {
        $('#mini-cart').fadeIn();
        $('.mini-cart__overlay').fadeIn();
      setTimeout(function() {
        $('#mini-cart').fadeOut();
        $('.mini-cart__overlay').fadeOut();
    }, 4000); // 4000 milliseconds = 4 seconds
    }

    function closeMiniCart() {
        $('#mini-cart').fadeOut();
        $('.mini-cart__overlay').fadeOut();
    }

    // Close mini cart when clicking close button or outside overlay
    $('.mini-cart__close, .mini-cart__overlay').on('click', closeMiniCart);
});

$(document).ready(function() {
    function updateCartCounter() {
        $.getJSON('/cart.js', function(data) {
            $(".cart-count").text(data.item_count);
        }).fail(function(error) {
            console.error('Error:', error);
        });
    }

    // Call the function to update the cart counter on page load
    updateCartCounter();
});

*/
// Requires buttons like: <button class="add-to-cart-btn" data-variant-id="123" data-max="3">Add to Cart</button>

$(function () {
  // Global cache of cart quantities per variant
  window.cartVariantCounts = {};

  // --- Boot ---
  bindMiniCartClose();
  bindAddToCartClicks();
  refreshCartState(); // load counts & cart counter on page load

  // --- Click handler (delegated) ---
  function bindAddToCartClicks() {
    $(document).on('click', '.add-to-cart-btn', function () {
      const $btn = $(this);
      if ($btn.data('busy')) return; // guard against rapid double-clicks during a request

      const variantId = Number($btn.data('variant-id'));
      const maxAttr = parseInt($btn.data('max'), 10);
      const maxQty = Number.isFinite(maxAttr) ? maxAttr : Infinity;

      const currentQty = (window.cartVariantCounts && window.cartVariantCounts[variantId]) || 0;

      // At/over limit? show alert and stop (button remains enabled)
      if (currentQty >= maxQty) {
        alert("You've added the maximum quantity we currently have in stock.");
        return;
      }

      // Proceed to add 1
      $btn.data('busy', true);
      addToCart(variantId, function onSuccess(item) {
        openMiniCart();
        renderMiniCartItem(item);
        refreshCartState(); // re-sync counts & header counter
      }, function onError() {
        // Optionally you can alert a friendly message here
      }, function always() {
        $btn.removeData('busy');
      });
    });
  }

  // --- Cart ops ---
  function addToCart(variantId, onSuccess, onError, onAlways) {
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: JSON.stringify({ id: variantId, quantity: 1 }),
      dataType: 'json',
      contentType: 'application/json',
      success: function (item) {
        console.log('Item added to cart:', item);
        if (typeof onSuccess === 'function') onSuccess(item);
      },
      error: function (xhr) {
        console.error('Add to cart error:', xhr);
        if (typeof onError === 'function') onError(xhr);
      },
      complete: function () {
        if (typeof onAlways === 'function') onAlways();
      }
    });
  }

  function refreshCartState() {
    $.getJSON('/cart.js', function (cart) {
      // rebuild variant counts from server cart
      window.cartVariantCounts = {};
      (cart.items || []).forEach(function (line) {
        window.cartVariantCounts[line.variant_id] =
          (window.cartVariantCounts[line.variant_id] || 0) + line.quantity;
      });

      // header counter
      $('.cart-count').text(cart.item_count);

      // update optional data-remaining for UI badges, if you use them
      refreshButtonsMeta();
    }).fail(function (err) {
      console.error('Cart fetch error:', err);
    });
  }
/*
  function refreshButtonsMeta() {
    $('.add-to-cart-btn').each(function () {
      const $btn = $(this);
      const variantId = Number($btn.data('variant-id'));
      const maxAttr = parseInt($btn.data('max'), 10);
      const maxQty = Number.isFinite(maxAttr) ? maxAttr : Infinity;
      const currentQty = window.cartVariantCounts[variantId] || 0;
      const remaining = maxQty === Infinity ? '' : Math.max(0, maxQty - currentQty);
      $btn.attr('data-remaining', remaining); // for optional CSS badge
    });
}
  */

    function refreshButtonsMeta() {
  $('.add-to-cart-btn').each(function () {
    const $btn = $(this);
    const variantId = Number($btn.data('variant-id'));
    const maxAttr = parseInt($btn.data('max'), 10);
    const maxQty = Number.isFinite(maxAttr) ? maxAttr : Infinity;
    const currentQty = window.cartVariantCounts?.[variantId] || 0;
    const remaining = maxQty === Infinity ? '' : Math.max(0, maxQty - currentQty);
    $btn.attr('data-remaining', remaining);
  });

// ✅ Attach event handler once (delegated and namespaced)
$(document).off('click.addtocart').on('click.addtocart', '.add-to-cart-btn', function (e) {
  e.preventDefault();
  const variantId = $(this).data('variant-id');
  const quantity = 1; // or your chosen qty
  handleAddToCart(variantId, quantity);
});



  }

  // --- Mini cart UI (your existing bits) ---
  function renderMiniCartItem(item) {
    const $miniCartItemsContainer = $('.mini-cart__items');
    $miniCartItemsContainer.empty().append(`
      <div class="mini-cart__item d-flex align-items-center">
        <img src="${item.image}" alt="${item.title}" class="mini-cart__item-image img-fluid rounded" style="max-width:50px; max-height:50px; margin-right:10px;">
        <div class="mini-cart__item-details">
          <h5 class="mb-1">${item.title}</h5>
        </div>
      </div>
    `);
  }

  function openMiniCart() {
    $('#mini-cart').fadeIn();
    $('.mini-cart__overlay').fadeIn();
    setTimeout(function () {
      $('#mini-cart').fadeOut();
      $('.mini-cart__overlay').fadeOut();
    }, 4000);
  }

  function bindMiniCartClose() {
    $('.mini-cart__close, .mini-cart__overlay').on('click', function () {
      $('#mini-cart').fadeOut();
      $('.mini-cart__overlay').fadeOut();
    });
  }


  // --- Handle Restock Rocket pre-order buttons gracefully ---
$(document).on('click.preventDoubleAdd', '.restock-rocket-preorder-button', function (e) {
  // Prevent double /cart/add.js calls
  if ($(this).data('restock-handled')) return; // guard against re-entry
  $(this).data('restock-handled', true);

  console.log('Restock Rocket pre-order button detected — skipping duplicate add, refreshing cart.');

  // Wait a bit to let Restock Rocket finish its own add
  setTimeout(function () {
    // Re-sync cart & update minicart UI
    $.getJSON('/cart.js', function (cart) {
      const lastItem = cart.items[cart.items.length - 1];
      if (lastItem) {
        openMiniCart();
        renderMiniCartItem(lastItem);
      }
      refreshCartState(); // update counts etc.
    });
  }, 1000); // slight delay to allow Restock Rocket to finish adding

  // Stop your own /cart/add.js request from firing
  e.stopImmediatePropagation();
});


});

